import { Controller } from "stimulus";
import fetchNoCache from "../functions/fetchNoCache.js";
import fetchUrl from "../functions/fetchUrl.js";
import cleanHtml from "../functions/cleanHtml.js";
import { removeAjaxPending } from "../functions/ajaxPending.js";
import displayFlashMessage from "../functions/displayFlashMessage.js";

export default class extends Controller {
  static get targets() {
    return ["contentArea"];
  }

  connect() {
    if (!this.preventInitialLoad) {
      this.load();
    }
  }

  _fetchQueryString(event) {
    if (!event) {
      return "";
    }

    return event.detail.queryString || "";
  }

  load(event) {
    this.showOverlay();
    const element = this.element;
    const url = fetchUrl(
      this.element.dataset.url,
      this._fetchQueryString(event),
    );

    fetchNoCache(url)
      .then((response) => {
        if (!response.ok) {
          // check if response is json that contains json messages
          // i.e. validation error messages through search GET requests
          const contentType = response.headers.get("content-type");
          if (contentType && contentType.indexOf("application/json") !== -1) {
            response.json().then(data => {
              data.messages.forEach(function (message) {
                displayFlashMessage(message);
              });
            });
            throw Error(response.statusText);
          }
        }

        if (response.headers.get("REQUIRES_AUTH") === "1") {
          window.location.replace(this.element.dataset.redirectUrl);
        } else {
          return response.text();
        }
      })
      .then((html) => {
        const element = this.contentAreaTarget;
        element.innerHTML = cleanHtml(html);
        removeAjaxPending(element);
        this.hideOverlay();
      })
      .catch((error) => {
        console.error(error);
        removeAjaxPending(element);
        this.hideOverlay();
      });
  }

  showOverlay() {
    const event = new CustomEvent("overlay:show", { bubbles: true });
    this.element.dispatchEvent(event);
  }

  hideOverlay() {
    const event = new CustomEvent("overlay:hide", { bubbles: true });
    this.element.dispatchEvent(event);
  }

  get preventInitialLoad() {
    return this.element.dataset.preventInitialLoad === "true";
  }
}
